import {
  formatCostEstimateDecimal,
  formatCostEstimateRoundingMode,
  formatCostEstimateTotal,
} from '#/modules/crmMgmt/costEstimate/helper/costEstimateFormat';
import { formatDateTimeOrDash } from '#/utils/date';

function dash(value) {
  if (value === null || value === undefined || value === '') {
    return '-';
  }
  return value;
}

export const costEstimateSideMsgDetailBlock = {
  fields: [
    { label: '試算名稱', value: 'name' },
    { label: '幣別', value: () => 'TWD' },
    { label: '總額取整', value: (row) => formatCostEstimateRoundingMode(row?.roundingMode) },
    { label: '未取整合計', value: (row) => formatCostEstimateDecimal(row?.amountSummary?.subtotalAmount) },
    { label: '總額', value: (row) => formatCostEstimateTotal(row?.amountSummary?.totalAmount) },
    { label: '明細數', value: (row) => (row?.lines ?? []).length },
    { label: '建立時間', value: (row) => formatDateTimeOrDash(row?.record?.createdAt) },
    { label: '更新時間', value: (row) => formatDateTimeOrDash(row?.record?.updatedAt) },
    { label: '備註', value: (row) => dash(row?.remark) },
  ],
};
